import { PARTNER } from "./Constant";

export const SYSTEM_SOURCE = "PARTNER_PORTAL_APP";

export const ALLOW_EXCEL_FILES = ["xlsx", "xls"];
export const RECORDS_PER_BATCH = 20;
export const ROLE_FOR_GT_ONLY = ["GENITS", "GENADM"];

export const PARTNER_WITH_MFA_EMAIL = [PARTNER.RETAIL];
export const PARTNER_WITH_MFA_TOTP = [PARTNER.SSW, PARTNER.TG, PARTNER.AGENCY];
export const PARTNER_WITH_SSO = [
  PARTNER.TISCO,
  PARTNER.KKP,
  PARTNER.GENERALI,
  PARTNER.RETAIL,
  PARTNER.ICBC,
  PARTNER.KA,
  PARTNER.TSR,
  PARTNER.AGENCY,
];

export const DEVICE_REMEMBERED_DAYS = 30;
export const DEVICE_REMEMBERED_MS =
  DEVICE_REMEMBERED_DAYS * 24 * 60 * 60 * 1000;
